import { actionTypes } from '../../types';

// Action creator for generating OTP request
export const videoIdApprovalActionByAdmin = (payload) => ({
    type: actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const videoIdApprovalActionByAdminSuccess = (payload) => ({
    type: actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const videoIdApprovalActionByAdminFailure = (payload) => ({
    type: actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_FAILURE,
    payload,
});

export const videoIdApprovalActionByAdminReset = () => ({
    type: actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_RESET,
});

// Action creator for resetting all OTP generation reducer
export const videoIdApprovalActionByAdminResetAll = () => ({
    type: actionTypes.VIDEO_ID_APPROVAL_ACTION_BY_ADMIN_RESET_ALL,
});
